import { InputBase, InputTimeController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

import { Objects } from "@salaxy/core";

/**
 * Input component for time
 * @example
 * ```html
 * <salaxy-input-time type="minutes" name="workTime" label="Worktime" required></salaxy-input-enum>
 * <salaxy-input-time type="isoTime" name="workTime" label="Worktime" required></salaxy-input-enum>
 * ```
 */
export class InputTime extends ComponentBase {

  /** ng-model is required, form tag is optionally used for validation and disabled/readonly */
  public require = {
    model: "ngModel",

    form: "?^^form",
  };

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = Objects.extend(InputBase.crudBindings, {
    /**
     * Used type in input. Types are minutes and isoTime
     */
    type: "@",
  });

  /** Uses the InputTimeController */
  public controller = InputTimeController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/form-controls/InputTime.html";
}
